import React from "react";
import { Table, Popup } from "semantic-ui-react";
import moment from "moment";
import "./BotRunsHistory.styles.scss";

const BotRunsHistory = ({ botRunsHistory = [] }) => {
  return (
    <Table celled striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={3}>ID</Table.HeaderCell>
          <Table.HeaderCell width={2}>Type</Table.HeaderCell>
          <Table.HeaderCell width={3}>Queue Receipt Handle</Table.HeaderCell>
          <Table.HeaderCell width={4}>Created At</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {botRunsHistory.map((run) => (
          <Table.Row key={run.id}>
            <Table.Cell>{run.id}</Table.Cell>
            <Table.Cell>{run.type}</Table.Cell>
            <Table.Cell className="truncate-cell">
              <Popup
                content={run.queueReceiptHandle}
                trigger={
                  <span className="truncate-text">
                    {run.queueReceiptHandle}
                  </span>
                }
                position="top center"
              />
            </Table.Cell>
            <Table.Cell>
              {moment(run.createdAt).format("DD-MMM-YYYY HH:mm:ss")}
            </Table.Cell>
          </Table.Row>
        ))}
        {botRunsHistory.length === 0 && (
          <Table.Row>
            <Table.Cell colSpan="4" textAlign="center">
              No bot runs history available
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
};

export default BotRunsHistory;
